<template>
  <div class="container">
    <div class="row g-4">
      <!-- Sidebar -->
      <div class="col-lg-3 d-none d-lg-block">
        <sidebar-component
          :top-books="topTenBooks"
          :best-seller-books="bestSellerBooks"
          :side-banner="sideBanner"
          :analytics="analytics"
        />
      </div>

      <!-- Main Content Area -->
      <div class="col-lg-9">
        <hero-section :hero-banner="heroBanner" />
        <book-categories :bookList="bookList" :isLoading="isLoading" />
        <promotion-banner :banners="weekendDealBanner" />
        <deals-slider :deals-list="dealsBooks" />
        <promotion-banner :isSingleBanner="true" :banners="fullWidthBanner" />
        <product-grid-section
          :bookList="productGridItems"
          :isLoading="isLoading"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { defineAsyncComponent } from 'vue';
import axios from "axios";
import { BASE_URL } from "@/globals";
import SidebarComponent from "@/components/SidebarComponent.vue";
import HeroSection from "@/components/HeroSection.vue";
// import BookCategories from "@/components/BookCategories.vue";
import PromotionBanner from "./PromotionBanner.vue";
import DealsSlider from "./DealsSlider.vue";
import ProductGridSection from "./ProductGridSection.vue";

export default {
  name: "MainBody",
  components: {
    SidebarComponent,
    HeroSection,
    BookCategories: defineAsyncComponent(() =>
      import("@/components/BookCategories.vue")
    ),
    PromotionBanner,
    DealsSlider,
    ProductGridSection,
  },
  data() {
    return {
      bookList: [],
      featuredBooks: [],
      bestSellerSingle: {},
      topTenBooks: [],
      bestSellerBooks: [],
      dealsBooks: [],
      productGridItems: [],
      isLoading: false,
      heroBanner: [],
      weekendDealBanner: [],
      fullWidthBanner: [],
      sideBanner: [],
      analytics: {},
    };
  },
  mounted() {
    this.fetchPreviewBooks();
  },
  methods: {
    async fetchPreviewBooks() {
      try {
        this.isLoading = true;
        const response = await axios.get(
          `${BASE_URL}/api/products/preview/home`
        );
        if (Object.keys(response.data).length) {
          this.bookList = response.data;
          this.featuredBooks = response.data.featured;
          this.bestSellerSingle = response.data.bestSeller[0]?.book;
          this.topTenBooks = response.data.topTen;
          this.bestSellerBooks = response.data.bestSeller;
          this.dealsBooks = response.data.deals;
          this.productGridItems = response.data.productGrid;

          // Add Banners data
          this.heroBanner = response.data.homeBanners.hero;
          this.weekendDealBanner = response.data.homeBanners.weekendDeal;
          this.fullWidthBanner = response.data.homeBanners.fullWidth;
          this.sideBanner = response.data.homeBanners.sideBanner;
          this.analytics = response.data.analytics;
        }
      } catch (error) {
        console.error("Error fetching books:", error);
      } finally {
        this.isLoading = false;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
</style>

